module.exports = __webpack_public_path__ + "img/kaimentu@2x.c3a61727.png";